import React, { Component } from 'react';
import Modal, {closeStyle} from 'simple-react-modal'
import './App.css';
import $ from 'jquery';
import ReactTooltip from 'react-tooltip';
import video_diary from './video_diary.json'
import aloe_vera from './aloe_vera.json'
import jeff_introduction from './jeff_introduction.json'
import vlog_competition from './vlog_competition.json'
import sports from './sports.json'
import anxiety from './anxiety.json'
import struggling from './struggling.json'
import yoga_vibe from './yoga_vibe.json'
import fit_traveler from './fit_traveler.json'
//import economics from './economics.json'
import dog_adoption from './dog_adoption_audio.json'
import economics from './shantanu_trimmed.json'

function HeaderPanel(props) {
  return null
  const thiz = props.context;
  return(
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="navbar-brand" style={{cursor:'pointer'}}>
          B-creative
          {thiz.state.doing_experiment && thiz.state.page===4 ? <button onClick={thiz.goToNextExperimentPage()} className='btn btn-primary text-center' style={{marginLeft: '30px'}}>Done and Next</button> : null}
          {thiz.state.doing_experiment && thiz.state.page===6 ? <label htmlFor="submit-form" tabIndex="0" className='btn btn-primary text-center' style={{marginLeft: '30px'}}>Done With Survey and Next</label> : null}
          {thiz.state.doing_experiment && thiz.state.page===7 ? <label htmlFor="submit-form" tabIndex="0" className='btn btn-primary text-center' style={{marginLeft: '30px'}}>Start First Task</label> : null}
        </div>
        <div className="collapse navbar-collapse" id="navbarTogglerDemo03">
          <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
            <li className="nav-item" >
            </li>
          </ul>
          <div className="my-2 my-lg-0 navbar-dark navbar-nav nav-link">
          </div>
          <div className="my-2 my-lg-0">
            <img alt="" src="./trash_white.png" width="40" height="40" draggable='true' onDragOver={thiz.preventDefault()} data-tip={"Drag B-roll to here to delete"} onDrop={thiz.brollDelete()}></img>
          </div>
        </div>
      </nav>
    );
}

function FooterPanel(props) {
  return null
  var thiz = props.context;
  if (thiz.state.page==4) {
	return(
      <nav className="navbar fixed-bottom navbar-expand-lg navbar-dark bg-dark">
        <div className="navbar-collapse center-block" id="navbarTogglerDemo03">
          <div className="navbar-nav mr-auto mt-2 mt-lg-0 text-light" style={{color:"rgba(255,255,255,.5)"}}>
            B-creative
          </div>
        </div>
        <div className="my-2 my-lg-0 btn btn-sm btn-warning helptext" onClick={thiz.toggleHelptext()}>
          {thiz.state.show_helptext ? "Hide Instructions" : "Show Detailed Instructions"}
        </div>
      </nav>
		);
  } else {
  return(
      <nav className="navbar fixed-bottom navbar-expand-lg navbar-dark bg-dark">
        <div className="navbar-collapse center-block" id="navbarTogglerDemo03">
          <div className="navbar-nav mr-auto mt-2 mt-lg-0 text-light" style={{color:"rgba(255,255,255,.5)"}}>
            B-creative
          </div>
        </div>
      </nav>
    );
  }
}

function CollaborativeFilters (props) {
  var thiz = props.context;
  if (thiz.state.uitype === "i") {
    return (
      <div style={{paddingLeft:"0px",textAlign: "left"}}>
        <button className="btn btn-outline-info btn-filter" onClick={thiz.changeRecommendationStyle("off")}>Off</button>
        <button className="btn btn-outline-info btn-filter" onClick={thiz.changeRecommendationStyle("audio")}>Audio</button>
        <button className="btn btn-outline-info btn-filter" onClick={thiz.changeRecommendationStyle("visual")}>Visual</button>
        <button className="btn btn-outline-info btn-filter" onClick={thiz.changeRecommendationStyle("text")}>Text</button>
        <button className="btn btn-outline-info btn-filter" onClick={thiz.changeRecommendationStyle("fast")}>Fast</button>
        <button className="btn btn-outline-info btn-filter" onClick={thiz.changeRecommendationStyle("magic")}>Magic</button>
      </div>
    );
  } else {
    return(null);
  }
}

function shuffle(a) {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}


function uploadDataToServer(thiz) {
    console.log("uploading data")
    var d = new Date();
    var n = d.getTime();
    const ztate = thiz.state;
    var version = n - thiz.state.sessionstarttime;
    var participantid = thiz.state.participantid;
    var broll_list = JSON.stringify(thiz.state.broll_list);
    console.log(broll_list)
    var queries = JSON.stringify({queries: thiz.state.queries});
    var usertype = ztate.usertype
    var uitype = ztate.uitype
    var videotype = ztate.videotype
    const apiURL = 'https://dapptalk.org/bcreate.php';
    const formData = {
      version: version,
      participantid: participantid%10000000,
      sessionid: thiz.state.experiment_index,
      broll_list: broll_list,
      queries: queries,
      usertype: usertype,
      uitype: uitype,
      videotype: videotype
    };
    fetch(apiURL, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin':'*',
      },
      body: JSON.stringify({
        formData,
      })
    }).then((response) => response.text())
      .then((responseData) => { console.log("response: ");console.log(responseData); })
      .catch((err) => { console.log(err); });
  }

function RecommendationQuestions(props) {
  var thiz = props.context
  console.log(thiz.state.ui_order[thiz.state.experiment_index-1])
  if (thiz.state.ui_order[thiz.state.experiment_index-1] !== 'i') {
    return (null);
  }
  //we only ask this in condition intelligent
  return (
    <span>
    {
      thiz.state.recommendation_questions.map((question, idx) => (
        <Likert key={'rec_'+idx} question={question} name={'q'+(idx+thiz.state.twenty_questions.length+thiz.state.five_questions.length)} labels={thiz.state.five_point_likert} context={thiz}/>
      ))
    }
    </span>
  )
}

function Likert(props) {
  const name = props.name
  const thiz = props.context
  var labels = props.labels
  if (name=='q12' && thiz.state.experiment_index > 0) {
    return(null);
  } 
  const question = props.question
  //console.log(name)
  return(
    <fieldset className="form-group">
      <div className="row border-bottom">
        <legend className="col-form-label col-sm-2 pt-0">{question}</legend><br/>
        <div className="col-sm-10">
          {name==='q4' ? <span style={{marginRight: '20px'}}>Perfect</span> : <span style={{marginRight: '20px'}}>{labels[0]}</span>}
          {labels.map((lab, idx) => (
            <div key={name+idx} className="custom-control custom-radio custom-control-inline big">
              <input type="radio" id={name+idx} name={name} value={idx+1} className="custom-control-input"/>
              <label className="custom-control-label big" htmlFor={name+idx}>{idx+1}</label>
            </div>
           ))}
          {name==='q4' ? <span>Failure</span> : <span>{labels[labels.length-1]}</span>}
        </div>
      </div>
    </fieldset>
  );
}

function generateRandomizedExperiment(thiz,u) {
    console.log('generateRandomizedExperiment')
    var possible_videos = [6,8,9];//[2,4,6,8,9]
    var possible_uis = ['b','i','t'];//this should be counterbalanced??
    var possible_recommendation_types = ['random','experts'];
    possible_recommendation_types = ['algorithm']
    shuffle(possible_videos);
    shuffle(possible_uis);
    shuffle(possible_recommendation_types);
    var instructions_order = [['b','i','t'].indexOf(possible_uis[0]),['b','i','t'].indexOf(possible_uis[1]),['b','i','t'].indexOf(possible_uis[2])]
    var transcripts = [video_diary,aloe_vera,jeff_introduction,vlog_competition,sports,anxiety,struggling,yoga_vibe,fit_traveler,economics]
    var v = possible_videos[0]//because we start with first element
    var words = transcripts[v].words
    var videotype = thiz.state.videotypes[v]
    console.log(instructions_order[0],"INSTRUCTIONS NUM",possible_uis,instructions_order)
    thiz.setState({usertype:u,uitype:possible_uis[0], videotype: videotype, v: v, words: words, page: 4, video_order: possible_videos, ui_order: possible_uis, recommendation_type: possible_recommendation_types[0], doing_experiment: true, experiment_index: 0, show_helptext: true, instructions_order: instructions_order, show_helptext: true, helptext: thiz.state.helptexts[instructions_order[0]]})
    return;
}

function getVideoIndex(thiz,u,c) {
  if (u !== 'e' && u !== 'n') {
    var vind = Math.floor(Math.random()*[2,4,6,8,9].length)
    var v = [2,4,6,8,9][vind]+""
    var transcripts = [video_diary,aloe_vera,jeff_introduction,vlog_competition,sports,anxiety,struggling,yoga_vibe,fit_traveler,economics]
    var words = transcripts[v].words
    var videotype = thiz.state.videotypes[v]
    console.log(videotype)
    thiz.setState({usertype:u,uitype:c, videotype: videotype, v: v, words: words, page: 4})
    return;
  }
  console.log('getVideoIndex')
  thiz.setState({page: 10})//means we are loading
  const apiURL = 'https://cors.io/?https://dapptalk.org/counterdatabase.php?c='+c+'&u='+u;
  fetch(apiURL, {
    method: 'GET',
    dataType: "json"
  }).then((response) => response.json())
    .then((responseData) => {
      var vind = responseData.session_id; 
      var session_id = responseData.session_id;
      //here we randomly assign: UI order,video order,recommendation type
      var possible_videos = [6,8,9];
      var possible_uis = ['t','b','i'];//this should be counterbalanced
      var possible_recommendation_types = ['random','experts'];
      possible_recommendation_types = ['algorithm']
      shuffle(possible_videos);
      shuffle(possible_uis);
      shuffle(possible_recommendation_types);
      vind = vind%5;
      var v = [2,4,6,8,9][vind]+""
      var transcripts = [video_diary,aloe_vera,jeff_introduction,vlog_competition,sports,anxiety,struggling,yoga_vibe,fit_traveler,economics]
      var words = transcripts[v].words
      var videotype = thiz.state.videotypes[v]
      console.log(videotype)
      thiz.setState({usertype:u,uitype:c, videotype: videotype, v: v, words: words, page: 4})
    })
    .catch((err) => { 
      console.log(err); 
    });
}

function TranscriptViewVeryIntelligent(props) {
  const thiz = props.context;
  var table = [];
  var words = props.context.state.words;
  var N = words.length;
  var counter_nonbreak = 0;
  var show_recommendations = (props.context.state.uitype === "i");

  const broll_list = props.context.state.broll_list;
  const num_added_broll = broll_list.length;

  var current_recommendation_style = thiz.state.current_recommendation_style;
  var videoname = thiz.state.videotype;
  var concepts = thiz.state.concepts_magic[videoname];
  
  if (thiz.state.recommendation_type === 'random') {
    concepts = thiz.state.concepts_magic[videoname];
  } else if (thiz.state.recommendation_type === 'algorithm') {
    concepts = thiz.state.concepts_magic[videoname];
  }

  if (current_recommendation_style === "off"){
    concepts = []
  }
  if (current_recommendation_style === "audio"){
    concepts = thiz.state.concepts_audio[videoname]
  }
  if (current_recommendation_style === "visual"){
    concepts = []
  }
  if (current_recommendation_style === "text"){
    concepts = thiz.state.concepts_text[videoname]
  }
  if (current_recommendation_style === "fast"){
    concepts = thiz.state.concepts_fast[videoname]
  }
  
  for (var i = 0; i < N; i++) {
    var word = words[i];
    var future_time = parseFloat(words[Math.min(N-1,i+1)].time);
    var prev_time = parseFloat(words[Math.max(0,i-1)].time);
    var current_time = parseFloat(word.time);
    var text = word.name;
    var this_concept = "";
    var currently_in_concept = false;
    var concept_start = 0;
    var suggested_duration = 4000;
    var first_in_concept = false;
    for(let j=0;j<concepts.length;j++) {
      var start_concept = concepts[j][1];
      var end_concept = concepts[j][1] + concepts[j][2];
      if (current_time > start_concept && current_time < end_concept) {
        concept_start = start_concept*1000;
        currently_in_concept = true;
        this_concept = concepts[j][0];
        suggested_duration = concepts[j][2]*1000;
        if (prev_time <= start_concept) {
          first_in_concept = true;
        }
        break
      }
    }
    if (!show_recommendations){
      currently_in_concept = false;
    }
    var currently_in_broll = false;
    var broll_id = 0
    var first_broll_word = false;
    var broll_thumbnail = ""
    var last_broll_word = false;

    for(let j=0;j<num_added_broll;j++){
      var start_broll = broll_list[j].start
      var end_broll = start_broll + broll_list[j].duration/1000
      if (current_time > start_broll && (current_time <= end_broll || prev_time <= start_broll)) {
        broll_thumbnail = broll_list[j].thumbnail
        broll_id = broll_list[j].id;
        currently_in_broll = true;
        if (prev_time <= start_broll) {
          first_broll_word = true;
        }
        if (!(future_time > start_broll && (future_time <= end_broll || current_time <= start_broll))) {
          last_broll_word = true;
        }
        break
      }
    }

    if (!("."===text))
      text = " " + text;

    if(future_time > thiz.state.currentTimeAroll/1000 && current_time <= thiz.state.currentTimeAroll/1000) {
      /*
        CURRENT POSITION
      */  
      if (first_broll_word) {
        //on mouse down it should register current broll index
        //on mouse up it should update the position of the currently registered broll
        table.push(<img src={broll_thumbnail} className="grab" alt="Broll thumbnail" width="20" height="20" draggable='true' onDragStart={thiz.brollDragStartHandler(broll_id)} key={i+"a"}/>)
      }
      table.push(<span key={i+"b"} className="bg-primary text-white text-transcript" onClick={props.context.clickTranscriptIntelligent(current_time*1000,i,"")} onContextMenu={thiz.firstMethod(text)}>{text}</span>);
    } else {
      /*
        B-ROLL
      */  
      if (currently_in_broll){
        if (first_broll_word) {
          //on mouse down it should register current broll index
          //on mouse up it should update the position of the currently registered broll
          table.push(<img src={broll_thumbnail} className="grab-timeline-move" alt="Broll thumbnail" width="20" height="20" draggable='true' onDragStart={thiz.brollDragStartHandler(broll_id)} key={i+"c"}/>)
        }
        if (last_broll_word) {
          table.push(<span className="bg-success text-transcript border-4 border-right border-dark grab-timeline-resize" draggable='true' onDragStart={thiz.brollDragDurationHandler(broll_id)} key={i+"d"}>{text}</span>);
        } else {
          table.push(<span draggable='true' className="bg-success text-transcript" onDragOver={thiz.preventDefault()} onDrop={thiz.brollDropHandler2(current_time,"onlydurationchange",broll_id)} key={i+"e"}>{text}</span>);
        }
      } else if (currently_in_concept){
        table.push(<span className="bg-info text-transcript" data-tip={this_concept} onClick={props.context.getImagesByQueryTerm(this_concept,concept_start/1000,suggested_duration)} draggable='true' onDragOver={thiz.preventDefault()} onDrop={thiz.brollDropHandler(current_time)} key={i+"f"}>{text}</span>);
        if (first_in_concept) {
          table.push(<button className="btn btn-outline-secondary btn-concept" onClick={props.context.getImagesByQueryTerm(this_concept,concept_start/1000,suggested_duration)} key={i+"g"}>{this_concept}</button>)
        }
      } else {   
        /*
          UNHIGHLIGHTED
        */  
        table.push(<span draggable='true' className="text-transcript" onDragOver={thiz.preventDefault()} onDrop={thiz.brollDropHandler(current_time)} onClick={props.context.clickTranscriptIntelligent(current_time*1000,i,"")} onContextMenu={thiz.firstMethod(text)} key={i+"h"}>{text}</span>);
      }
    }
    if (word.name === "."){
      if (counter_nonbreak > 15) {
        table.push(<div className="textbreak" key={i+"i"}></div>);
        counter_nonbreak = 0
      }
    }
    counter_nonbreak += 1;
  }
  return table
}

function TimelineView(props) {
  const thiz = props.context;
  const broll_list = props.context.state.broll_list;
  const num_added_broll = broll_list.length;

  var table = [];
  var words = props.context.state.words;
  var N = words.length;
  if (N < 1) {
    return table;
  }

  var totalDuration = parseFloat(words[N-1].duration) + parseFloat(words[N-1].time);

  var timestep = totalDuration / N;

  for (var i = 0; i < N; i++) {
    var word = words[i];
    var future_time = timestep*(i+1);
    var prev_time = timestep*(Math.max(0,i-1));
    var current_time = timestep*i;

    var currently_in_broll = false;
    var broll_id = 0
    var first_broll_word = false;
    var broll_thumbnail = ""
    var last_broll_word = false;

    for(let j=0;j<num_added_broll;j++){
      var start_broll = broll_list[j].start
      var end_broll = start_broll + broll_list[j].duration/1000
      if (current_time > start_broll && (current_time <= end_broll || prev_time <= start_broll)) {
        broll_id = broll_list[j].id;
        currently_in_broll = true;
        if (current_time-start_broll <= end_broll - current_time) {
          first_broll_word = true;
        } else {
          last_broll_word = true;
        }
        break
      }
    }

    var word_width = (100.0 / N)+'%';

    /*
      RENDERING STARTS
    */
    if(future_time > thiz.state.currentTimeAroll/1000 && current_time <= thiz.state.currentTimeAroll/1000) {
      /*
        CURRENT POSITION
      */ 
      table.push(<span key={i} className="bg-primary word-timeline" style={{width:word_width, cursor:'pointer'}} draggable='true' onDragOver={thiz.preventDefault()} onDrop={thiz.brollDropHandler(current_time)} onClick={thiz.clickTranscriptIntelligent(current_time*1000,i,"")}></span>)
    } else if (currently_in_broll){
      /*
        INSIDE B-ROLL
      */ 
      if (first_broll_word) {
        table.push(<span key={i} className="bg-success word-timeline grab-timeline-move" style={{width:word_width}} draggable='true' onDragStart={thiz.brollDragStartHandler(broll_id)} onDragOver={thiz.preventDefault()} onDrop={thiz.brollDropHandler2(current_time,"onlydurationchange",broll_id)}></span>)
      } else if (last_broll_word) {
        table.push(<span key={i} className="bg-success word-timeline grab-timeline-resize" style={{width:word_width}} draggable='true' onDragStart={thiz.brollDragDurationHandler(broll_id)} onDragOver={thiz.preventDefault()} onDrop={thiz.brollDropHandler2(current_time,"onlydurationchange",broll_id)}></span>);
      } else {
        table.push(<span draggable='true' className="bg-success word-timeline" style={{width:word_width}} onDragOver={thiz.preventDefault()} onDrop={thiz.brollDropHandler2(current_time,"onlydurationchange",broll_id)} key={i}></span>);
      }
    } else {
      /*
        NOTHING
      */ 
      table.push(<span key={i} className="bg-white word-timeline" style={{width:word_width}} draggable='true' onDragOver={thiz.preventDefault()} onDrop={thiz.brollDropHandler(current_time)} onClick={thiz.clickTranscriptIntelligent(current_time*1000,i,"")}></span>)
    }
  }
  return table;
}

function EditingViewBaseline(props) {
	const thiz = props.context;
  var aroll_videofile = "./"+thiz.state.videotype+".mp4"
  var totaltimestamp = "03:05"
  if (document.getElementById("aroll") != null) {
    var dur = document.getElementById("aroll").duration
    totaltimestamp = ("00" + parseInt(dur/60,10)).slice(-2)+":"+("00" + parseInt(dur%60,10)).slice(-2)
  }
  if ("aN:aN" === totaltimestamp) {
    totaltimestamp = "03:05"
  }
	return(
  	<div> 
      {thiz.state.broll_list.map((broll_obj, idx) => (
  			<video width="600" height="360" className="broll" style={{display: 'none'}} id={"broll_"+idx} loop>
  				<source src={broll_obj.url} type="video/mp4"/>
  				Your browser does not support the video tag.
  		  </video>
       ))}
  		<video width="600" height="360" id="aroll" onClick={thiz.arollPlay()} onTimeUpdate={thiz.callingUpdate()} key={aroll_videofile}>
  			<source src={aroll_videofile} type="video/mp4"/>
  			Your browser does not support the video tag.
  		</video>
  	  <div>
    		<button type="button" onClick={thiz.arollPlay()} className="btn btn-secondary left-buffer">Play / Pause</button>
    		<button type="button" onClick={thiz.arollReplay()} className="btn btn-secondary">Replay</button>
        <span className="left-buffer top-buffer-sm">{thiz.state.timestamp}/{totaltimestamp}</span>
  	  </div>
  	</div>
	);
}

function RenderBrollResultIntelligent(props) {
    const thiz = props.context;
    const type = props.type;
    var table1 = []
    var broll_footage = thiz.state.broll_footage.social;
    var broll_thumbnail = thiz.state.broll_thumbnail.social;
    if (type === "professional") {
      var broll_footage = thiz.state.broll_footage.professional;
      var broll_thumbnail = thiz.state.broll_thumbnail.professional;
    }
    var N = broll_footage.length;
    const maxindex = Math.min(N,thiz.state.maxindex);
    if (maxindex < 1) {
      return table1
    }
    var per_row = 4;
    // Outer loop to creaSearte parent
    for (var i = 0; i < maxindex; i+=per_row) {
      var children = []
      //Inner loop to create children
      for (let j = 0; j < per_row; j++) {
        children.push(
          <div className="col-3" key={broll_footage[i+j]+"_col"}>
          <video width="200" height="200" key={broll_footage[i+j]} id={broll_footage[i+j]} name="broll" controls autoPlay loop muted>
            <source src={broll_footage[i + j]} type="video/mp4"/>
            Your browser does not support the video tag.
          </video>
          <button onClick={thiz.addNow(broll_footage[i + j],broll_thumbnail[i+j],i+j)} className="btn btn-primary">Add Now</button>
        </div>
          )
      }
      //Create the parent and add the children
      table1.push(<div key={i} className="row top-buffer">{children}</div>)
    }
    return table1
}

function showThisBroll (name,duration) {
	if(document.readyState === "complete") {
  	$("#"+name).show();
  	document.getElementById(name).currentTime=0;
  	document.getElementById(name).play();
  	$("#aroll").hide();
  	setTimeout(function(){
  		$("#"+name).hide();
  		$("#aroll").show();
  	}, duration);
	}
}

function generateStockToken(thiz) {
  console.log('generateStockToken')
  const apiURL = 'https://cors.io/?https://ims-na1-stg1.adobelogin.com/ims/login/v1/token?client_id=ImageServicesTestAutomation1&username=bhuber%2B1%40adobe.com&password=Bcreate123!&scope=AdobeID,creative_sdk&response_type=token&remember_me=false';
  fetch(apiURL, {
    method: 'GET',
    dataType: "json"
  }).then((response) => response.json())
    .then((responseData) => {
      var access_token = responseData.access_token
      console.log(access_token)
      if(access_token.length > 100){
        thiz.setState({token:access_token})
      }
    })
    .catch((err) => { 
      console.log(err); 
    });
}

var prev_pos = 0;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 4,
      participantid: Date.now(),
      broll_footage: {"social":[],"professional":[]},
      justclicked: false,
      searchkey: "",
      broll_list: [],
      timestamp: "00:00",
      sessionstarttime: Date.now(),
      suggested_start_time: -1,
      token: "eyJ4NXUiOiJpbXNfbmExLXN0ZzEta2V5LTEuY2VyIiwiYWxnIjoiUlMyNTYifQ.eyJpZCI6IjE1Mzc0NjM1NjQ3MzhfZDU0MWFmNDAtMjU5OC00NmY2LWEwODMtMmM5Y2Y0YjkyOTJhX3VlMSIsImNsaWVudF9pZCI6IkltYWdlU2VydmljZXNUZXN0QXV0b21hdGlvbjEiLCJ1c2VyX2lkIjoiMzg1NDQxQjM1QjI0MUYzMTBBNDk0MDBFQEFkb2JlSUQiLCJ0eXBlIjoiYWNjZXNzX3Rva2VuIiwiYXMiOiJpbXMtbmExLXN0ZzEiLCJmZyI6IlNZN0NST0xEV1Y3Rzc1N0ROV0xNT1NJQVNBPT09PT09Iiwic2lkIjoiMTUzNzQ2MzU2NDc0MV8wZTEzMWFmNy1mYzM2LTQ4Y2EtODA4OS0yODAwMmEzMzVlYjFfdWUxIiwibW9pIjoiYWE4MmE2NmIiLCJjIjoiZzdncnRuRk1aLzBPUkdBQmRJQ1BjUT09IiwiZXhwaXJlc19pbiI6Ijg2NDAwMDAwIiwic2NvcGUiOiJBZG9iZUlELGNyZWF0aXZlX3NkayIsImNyZWF0ZWRfYXQiOiIxNTM3NDYzNTY0NzM4In0.SW1X-LWLAakB6oMnY29s_NHLrYOaiGZqgNw49imEG2GCBHWBlrOEL8cQxFlfVVRZxjjYIx28DMtwxlfm4-SbsAAhNomKkEEqJ3pwJZU-5POelXXUTNil_uKW8ItXAPinWVkksMCrvHUJrk2mj0UDuZFmL8AAOubdP2zCRmG_334gCuUR30NxA7dp1jv7OeNjAiM6scVnikfLAIIh4IDW5a1hCeEmWJCR2vOLv-K7QkvsvSfFDEGA2-ZddJCFmsrVKgS24WxXWAYQO-_ws87SZySBWDooFL15SEXAizrvh0gOrAXnP9gQnVrHgx7XHv1sQWeJn95Qb3c4sdo0nMMT0w",
      loadingBroll: false,
      words: [],      
      queries: [],
      suggested_duration: 4000,
      concepts_algorithm: {'jeff_introduction': [['jeff', 4.58, 2.0], ['series', 15.59, 2.0], ['solutions', 24.83, 2.0], ['variety', 33.47, 2.0], ['people', 42.95, 2.0], ['asian culture', 55.98, 2.0], ['hip hop', 67.08, 2.0], ['spin', 85.38, 2.0], ['subgroups', 93.81, 2.0], ['main influences', 107.37, 2.0], ['religions', 120.84, 2.0], ['date', 128.97, 2.0], ['problem', 138.15, 2.0], ['people', 148.17, 2.0], ['everybody', 159.0, 2.0], ['booty', 168.51, 2.0], ['table', 177.87, 2.0]], 'struggling': [['mornings', 7.68, 2.0], ['care', 16.35, 2.0], ['people', 24.35, 2.0], ['people', 32.88, 2.0], ['life', 42.78, 2.0], ['passion', 53.76, 2.0], ['thing', 63.96, 2.0], ['somebody', 75.51, 2.0], ['break', 84.06, 2.0], ['guy', 94.17, 2.0], ['rest', 103.44, 2.0], ['aspects', 115.35, 2.0], ['periods', 124.11, 2.0], ['school', 132.42, 2.0], ['break', 141.66, 2.0], ['lessons', 149.91, 2.0], ['creativity', 162.3, 2.0], ['youtube', 172.68, 2.0]], 'economics': [['hand', 9.79, 2.0], ['video', 2.8, 2.0], ['transcript', 15.06, 2.0], ['edit', 21.32, 2.0], ['position', 27.91, 2.0], ['positions', 35.9, 2.0], ['insert', 41.18, 2.0], ['example', 46.47, 2.0], ['style', 51.69, 2.0], ['user', 59.12, 2.0]], 'fit_traveler': [['episode number', 1.24, 2.0], ['business', 11.59, 2.0], ['session', 20.41, 2.0], ['weekends', 33.01, 2.0], ['years', 42.91, 2.0], ['events', 55.3, 2.0], ['type', 68.32, 2.0], ['beast', 76.39, 2.0], ['invitation', 87.1, 2.0], ['drinks', 95.17, 2.0], ['business travelers', 105.04, 2.0], ['vendors', 114.34, 2.0], ['purposes', 131.5, 2.0], ['drink', 140.68, 2.0], ['times', 150.04, 2.0], ['picture', 161.26, 2.0], ['tips', 174.82, 2.0]], 'sports': [['world', 11.94, 2.0], ['breakfast', 26.65, 2.0], ['shot', 40.26, 2.0], ['breakfast', 49.53, 2.0], ['history', 63.96, 2.0], ['basilica', 75.48, 2.0], ['river', 83.79, 2.0], ['noon', 100.26, 2.0], ['pizza', 114.48, 2.0], ['lunch', 123.24, 2.0], ['match', 131.43, 2.0], ['girls', 141.0, 2.0], ['guys', 149.13, 2.0], ['floor', 158.94, 2.0], ['air conditioning', 168.37, 2.0], ['language', 179.55, 2.0]]},
      concepts_magic: {'struggling': [['stress', 4.6, 2.1], ['public figure', 22.0, 7.9], ['working', 38.4, 4.9], ['passion', 53.8, 4.0], ['happiness', 64.5, 0.5], ['lifting weights', 76.5, 7.5], ['injured', 94.8, 1.6], ['stronger', 108.1, 1.5], ['school', 132.5, 2.3], ['break', 141.6, 0.6], ['burned out', 158.3, 0.5], ['stressed', 165.1, 3.0], ['YouTube', 175.4, 1.3]], 'jeff_introduction': [['dating', 6.4, 4.3], ['address', 21.5, 0.5], ['pregnancy', 29.1, 4.1], ['coach', 37.6, 0.7], ['society', 44.1, 2.1], ['martial arts', 56.6, 3.3], ['peace', 65.3, 0.5], ['culture', 77.6, 1.4], ['culture', 88.0, 4.0], ['religions', 121.1, 1.6], ['Christianity', 135.2, 2.8], ['attracted', 152.1, 0.5], ['dating', 156.9, 0.5], ['booty', 168.6, 4.0]], 'economics': [['war', 8.54, 2.0], ['truth', 35.28, 2.0], ['embrace', 70.69, 2.0], ['share', 26.06, 2.0], ['dream', 54.45, 2.0], ['today', 0.86, 2.0], ['images', 14.06, 2.0], ['technology', 42.15, 2.0], ['hamas', 48.39, 2.0], ['economy', 59.64, 2.0]], 'fit_traveler': [['bar', 9.6, 4.0], ['alcohol', 25.4, 3.2], ['weekends', 33.0, 2.3], ['business', 49.3, 4.0], ['business traveler', 70.5, 4.0], ['business meeting', 80.7, 0.5], ['bar', 91.2, 4.5], ['happy hour', 111.7, 1.9], ['bar', 126.9, 0.5], ['business healthy', 167.1, 0.5]], 'sports': [['fathers day', 6.9, 2.3], ['morning', 24.3, 0.5], ['hot dogs', 31.7, 4.7], ['cinnamon', 45.2, 2.1], ['tram', 52.2, 4.0], ['basilica', 75.5, 4.0], ['pizza', 115.7, 4.5]]},
      concepts_random: {'struggling': [["I'm", 11.0, 2.0], ['unhealthy', 22.0, 2.0], ['people', 33.0, 2.0], ['always', 44.0, 2.0], ['and', 55.0, 2.0], ['that', 66.0, 2.0], ['weights', 77.0, 2.0], ['lifts', 88.0, 2.0], ['hard', 110.0, 2.0], ['I came', 132.0, 2.0], ['been going', 143.0, 2.0], ['out', 154.0, 2.0], ['and', 165.0, 2.0], ['analytics', 176.0, 2.0]], 'jeff_introduction': [['basic', 11.0, 2.0], ['problem', 22.0, 2.0], ['flu', 55.0, 2.0], ['expressions', 77.0, 2.0], ['culture', 88.0, 2.0], ['because', 99.0, 2.0], ['our', 110.0, 2.0], ['Many', 121.0, 2.0], ['thing', 132.0, 2.0], ['that', 143.0, 2.0], ['talk', 154.0, 2.0], ['the', 176.0, 2.0]], 'economics': [['like', 22.0, 2.0], ['chaos', 44.0, 2.0], ['people', 55.0, 2.0], ['religion', 66.0, 2.0], ['like', 99.0, 2.0], ['like', 110.0, 2.0], ['choices', 132.0, 2.0], ['their', 143.0, 2.0], ['make', 165.0, 2.0]], 'fit_traveler': [['as', 11.0, 2.0], ['expectations', 22.0, 2.0], ['the weekends', 33.0, 2.0], ['that', 44.0, 2.0], ['up', 55.0, 2.0], ['nightcap', 99.0, 2.0], ['companies', 110.0, 2.0], ['business', 121.0, 2.0], ['purposes', 132.0, 2.0], ['participate', 143.0, 2.0], ['the', 154.0, 2.0], ['in', 165.0, 2.0], ['or', 176.0, 2.0]], 'sports': [['Budapest', 11.0, 2.0], ['and', 33.0, 2.0], ['then', 55.0, 2.0], ['around', 88.0, 2.0], ['got', 99.0, 2.0], ['match', 132.0, 2.0], ['street from', 143.0, 2.0], ['hope', 154.0, 2.0], ['and', 176.0, 2.0]]},
      concepts_audio: {'struggling': [['because', 12.3, 4.0], ['.', 24.7, 4.0], ['example', 36.5, 4.0], ['.', 48.4, 4.0], ["that's", 58.5, 4.0], ['.', 69.0, 4.0], ['okay', 79.8, 4.0], ['.', 90.3, 4.0], ['example', 101.2, 4.0], ['grow', 113.5, 4.0], ['after', 125.5, 4.0], ['work', 137.1, 4.0], ['in', 148.7, 4.0], ['.', 159.0, 4.0], ['YouTube', 170.1, 4.0], ['.', 180.5, 4.0]], 'jeff_introduction': [['on', 14.0, 4.0], ['dating', 24.4, 4.0], ['And', 35.3, 4.0], ['hop', 46.6, 4.0], ['movies', 58.6, 4.0], ['where', 69.0, 4.0], ['Arab', 79.1, 4.0], ['to', 89.2, 4.0], ['because', 99.3, 4.0], ['influences', 109.6, 4.0], ['religions', 121.8, 4.0], ['the', 132.4, 4.0], ['that', 143.1, 4.0], ['them', 154.6, 4.0], ["that's", 165.0, 4.0], ['table', 175.7, 4.0]], 'economics': [['about', 10.9, 4.0], ['.', 21.0, 4.0], ['and', 31.2, 4.0], ['chaotic element to it', 41.9, 4.0], ['cannot', 52.1, 4.0], ['family', 65.5, 4.0], ['Like', 77.3, 4.0], ['.', 88.8, 4.0], ['road', 98.9, 4.0], ['like', 109.5, 4.0], ['consumption', 119.7, 4.0], ["don't", 130.0, 4.0], ['family', 140.5, 4.0], ['.', 152.8, 4.0], ['crime', 163.6, 4.0], ['normal', 174.3, 4.0]], 'fit_traveler': [['scene', 10.2, 4.0], ['drink', 26.2, 4.0], ['not', 37.4, 4.0], ['.', 47.9, 4.0], ['business', 59.9, 4.0], ['traveler', 71.7, 4.0], ['meeting', 82.6, 4.0], ['drinks', 95.6, 4.0], ['.', 108.4, 4.0], ['is', 120.1, 4.0], ['this', 132.9, 4.0], ['participate', 143.3, 4.0], ['OK', 154.8, 4.0], ['existence', 166.0, 4.0], ['or', 176.3, 4.0]], 'sports': [['world', 12.3, 4.0], ['830', 26.1, 4.0], ['But', 37.7, 4.0], ['yeah', 49.4, 4.0], ['.', 59.9, 4.0], ['building', 70.9, 4.0], ['War', 82.4, 4.0], ['especially', 92.5, 4.0], ['Budapest', 103.1, 4.0], ["let's", 113.7, 4.0], ['up', 124.3, 4.0], ['team', 135.2, 4.0], ['because', 147.1, 4.0], ['the', 159.1, 4.0], ['awesome', 169.8, 4.0], ['language', 180.1, 4.0]]},
      concepts_text: {'struggling': [['want', 12.8, 4.0], ['themselves', 29.8, 4.0], ['squeeze', 45.3, 4.0], ['the', 58.9, 4.0], ['explain', 70.1, 4.0], ['lifting', 82.9, 4.0], ['it', 96.7, 4.0], ['lifting', 107.9, 4.0], ['the', 120.7, 4.0], ['took', 134.5, 4.0], ['straighten', 153.1, 4.0], ['lost', 163.2, 4.0], ['checking', 174.8, 4.0]], 'jeff_introduction': [['get', 10.7, 4.0], ['the', 21.6, 4.0], ['call', 35.8, 4.0], ['the', 49.9, 4.0], ['the', 60.3, 4.0], ['bring', 75.4, 4.0], ['lose', 87.6, 4.0], ['influence', 100.9, 4.0], ['us', 118.7, 4.0], ['marry', 129.8, 4.0], ['address', 142.3, 4.0], ['a', 155.8, 4.0], ['the', 176.0, 4.0]], 'economics': [['swallow', 52.2, 4.0], ['their', 63.2, 4.0], ['addiction', 90.1, 4.0], ['addiction', 100.3, 4.0], ['addiction', 116.1, 4.0], ['the', 127.9, 4.0], ['their', 139.5, 4.0], ['breaking', 150.9, 4.0], ['make', 165.0, 4.0]], 'fit_traveler': [['the', 12.4, 4.0], ['that', 26.7, 4.0], ['addressing', 37.5, 4.0], ['the', 49.3, 4.0], ['some', 62.2, 4.0], ['this', 73.4, 4.0], ['the', 90.2, 4.0], ['a', 108.9, 4.0], ['a', 120.6, 4.0], ['the', 131.5, 4.0], ['have', 144.6, 4.0], ['that', 155.7, 4.0], ['healthy', 167.5, 4.0], ['adopt', 179.2, 4.0]], 'sports': [['day', 14.3, 4.0], ['had', 26.4, 4.0], ['breakfast', 36.6, 4.0], ['breakfast', 49.7, 4.0], ['the', 60.6, 4.0], ['saw', 71.4, 4.0], ['the', 83.7, 4.0], ['got', 98.9, 4.0], ['had', 113.0, 4.0], ['lunch', 123.5, 4.0], ['a', 134.1, 4.0], ['judge', 145.9, 4.0], ['the', 158.9, 4.0], ['the', 173.4, 4.0]]},
      concepts_fast: {'struggling': [['because', 20.0, 2.0], ['themselves', 30.0, 2.0], ['24/7', 40.0, 2.0], ['I', 50.0, 2.0], ['I', 60.0, 2.0], ['me', 70.0, 2.0], ['from', 80.0, 2.0], ["It's", 100.0, 2.0], ['hard', 110.0, 2.0], ["It's", 120.0, 2.0], ['rest', 130.0, 2.0], ['those', 150.0, 2.0], ['YouTube', 170.0, 2.0], ['worrying', 180.0, 2.0]], 'jeff_introduction': [['I', 10.0, 2.0], ['I', 20.0, 2.0], ['pregnancy', 30.0, 2.0], ['African-American', 50.0, 2.0], ['you', 60.0, 2.0], ['race', 70.0, 2.0], ['culture', 90.0, 2.0], ['subgroups', 100.0, 2.0], ['our', 110.0, 2.0], ['us', 120.0, 2.0], ['marry', 130.0, 2.0], ['one', 140.0, 2.0], ['most', 150.0, 2.0], ['goes', 160.0, 2.0], ['nice person', 170.0, 2.0], ['So', 180.0, 2.0]], 'economics': [['so', 20.0, 2.0], ['psychology', 30.0, 2.0], ['people', 60.0, 2.0], ['their', 70.0, 2.0], ['go', 80.0, 2.0], ['really', 90.0, 2.0], ['drug', 100.0, 2.0], ['like', 110.0, 2.0], ['economics', 120.0, 2.0], ['family', 140.0, 2.0], ['not', 150.0, 2.0], ['addiction', 160.0, 2.0], ['like', 170.0, 2.0]], 'fit_traveler': [['scene', 10.0, 2.0], ['talking', 30.0, 2.0], ['talking', 40.0, 2.0], ['setting', 50.0, 2.0], ['If', 70.0, 2.0], ['a', 80.0, 2.0], ['to', 100.0, 2.0], ['companies', 110.0, 2.0], ['is', 120.0, 2.0], ['going', 130.0, 2.0], ['to', 140.0, 2.0], ['the', 150.0, 2.0], ["Let's", 160.0, 2.0], ['new', 180.0, 2.0]], 'sports': [['so', 20.0, 2.0], ['had', 30.0, 2.0], ['everything', 40.0, 2.0], ['breakfast', 50.0, 2.0], ['Never', 60.0, 2.0], ['parliament', 70.0, 2.0], ['someone', 90.0, 2.0], ['was', 120.0, 2.0], ['and', 130.0, 2.0], ['Terra', 160.0, 2.0], ['language', 180.0, 2.0]]},
      concepts_video: [],
      current_recommendation_style: "magic",
      broll_thumbnail: {"social":[],"professional":[]},
      clickedBroll: -1,
      usertype: "e",
      uitype: "i",
      videotype: "dog_adoption",
      helptext: '<h4>What is my task?</h4><p>You will be given a video of a person talking. You are asked to insert short videos (“B-roll”) to make the video more engaging. The task will consist of you watching the video of the person talking, to select moments where to insert B-roll footage, and to select which B-roll footage to insert. Please insert a total of 8-10 B-roll.</p><h4>How should I edit the video?</h4><p>We will provide you a video editor in the browser. Here is how to use this video editor:</p><h4>Video navigation:</h4><p>A transcript of the video on the right is the main navigation tool. Click on a word in the transcript to go to that position in the video. The blue highlighted text shows you the current position in the video.</p><h4>B-roll search:</h4><p>There is a search interface at the bottom-left that allows you to search for B-roll. You can also right click on a word in the transcript to search for that word in the transcript. The results will show social media style B-roll and professionally shot B-roll video clips. You are free to choose any clip you want for the search term.</p><h4>B-roll insertion:</h4><p>To insert a B-roll, click on the ‘Add Now’ button appearing below the desired B-roll video clip. The B-roll will be added to the current position in the video.</p><h4>B-roll modification:</h4><p>You can move, change the duration, and delete every inserted B-roll. Move it by dragging the thumbnail on a word in the transcript to where you want to move the video. Drag the last word of the B-roll to change the duration. Drag the thumbnail onto the trashcan at the top right to delete the clip.</p>',
      helptexts: ['<p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 14pt;"><strong><span style="font-family: Arial; color: #212529; background-color: transparent; font-variant: normal; text-decoration-skip-ink: none; vertical-align: baseline; white-space: pre-wrap;">Video navigation:</span></strong></span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 12pt; font-family: Arial; color: #212529; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">A transcript of the video on the right is the main navigation tool. Click on a word in the transcript to go to that position in the video. </span><span style="font-size: 12pt; font-family: Arial; color: #000000; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">The blue highlighted text shows you the current position in the video. You can also use &lsquo;space&rsquo; to pause/play the video. <br/><img src="tutorial_navigate.gif" alt="Navigation Tutorial Image" height="200" width="350"></img></br> You can also right click on a word to search B-Roll with that word. <br/><img src="tutorial_search.gif" alt="Navigation Tutorial Image" height="200" width="350"></img></br></span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;">&nbsp;</p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><strong><span style="font-size: 14pt; font-family: Arial; color: #212529; background-color: transparent; font-variant: normal; text-decoration-skip-ink: none; vertical-align: baseline; white-space: pre-wrap;">B-roll modification:</span></strong></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 12pt; font-family: Arial; color: #212529; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">You can move, change the duration, and delete every inserted B-roll. Move it by dragging the thumbnail on a word in the transcript to where you want to move the video. Drag the last word of the B-roll to change the duration. Drag the thumbnail onto the trashcan at the top right to delete the clip. <br/><img src="tutorial_modify.gif" alt="Navigation Tutorial Image" height="200" width="350"></img></br></span></p><p>Click anywhere on this text to hide this text and start the task.</p>','<p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 14pt;"><strong><span style="font-family: Arial; color: #212529; background-color: transparent; font-variant: normal; text-decoration-skip-ink: none; vertical-align: baseline; white-space: pre-wrap;">Video navigation:</span></strong></span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 12pt; font-family: Arial; color: #212529; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">A transcript of the video on the right is the main navigation tool. Click on a word in the transcript to go to that position in the video. <br/><img src="tutorial_navigate.gif" alt="Navigation Tutorial Image" height="200" width="350"></img></br> </span><span style="font-size: 12pt; font-family: Arial; color: #000000; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">The blue highlighted text shows you the current position in the video. You can also use &lsquo;space&rsquo; to pause/play the video. You can also right click on a word to search B-Roll with that word. <br/><img src="tutorial_search.gif" alt="Navigation Tutorial Image" height="200" width="350"></img></br> </span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;">&nbsp;</p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><strong><span style="font-size: 14pt; font-family: Arial; color: #212529; background-color: transparent; font-variant: normal; text-decoration-skip-ink: none; vertical-align: baseline; white-space: pre-wrap;">B-roll modification:</span></strong></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 12pt; font-family: Arial; color: #212529; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">You can move, change the duration, and delete every inserted B-roll. Move it by dragging the thumbnail on a word in the transcript to where you want to move the video. Drag the last word of the B-roll to change the duration. Drag the thumbnail onto the trashcan at the top right to delete the clip. <br/><img src="tutorial_modify.gif" alt="Navigation Tutorial Image" height="200" width="350"></img></br> </span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 14pt;"><strong><span style="font-family: Arial; color: #212529; background-color: transparent; font-variant: normal; text-decoration-skip-ink: none; vertical-align: baseline; white-space: pre-wrap;">B-Roll recommendations:</span></strong></span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 12pt; font-family: Arial; color: #212529; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">This tool provides you recommendations for where you could insert B-roll, a recommended duration, and a potentially relevant query term. If you like one of the recommended videos, click \'Add Now\' to insert it in the recommended position with the recommended duration. <br/><img src="tutorial_recommend.gif" alt="Navigation Tutorial Image" height="200" width="350"></img></br> </span></p><p>Click anywhere on this text to hide this text and start the task.</p>','<p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 14pt;"><strong><span style="font-family: Arial; color: #212529; background-color: transparent; font-variant: normal; text-decoration-skip-ink: none; vertical-align: baseline; white-space: pre-wrap;">Video navigation:</span></strong></span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 12pt; font-family: Arial; color: #212529; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">A timeline below the video is the main navigation tool. Click on a position in the timeline to go to that position in the video. </span><span style="font-size: 12pt; font-family: Arial; color: #000000; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">The blue highlighted line shows you the current position in the video.</span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;">&nbsp;</p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 14pt;"><strong><span style="font-family: Arial; color: #212529; background-color: transparent; font-variant: normal; text-decoration-skip-ink: none; vertical-align: baseline; white-space: pre-wrap;">B-roll modification:</span></strong></span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 12pt; font-family: Arial; color: #212529; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">You can move, change the duration, and delete every inserted B-roll. Move it by dragging the highlighted inserted B-Roll in the timeline to where you want to move the video. Drag the end of the B-roll to change the duration. Drag the beginning of the B-Roll onto the trashcan at the top right to delete the clip.</span></p><p>Click anywhere on this text to hide this text and start the task.</p>'],
      show_helptext: false,
      v: 0,
      videotypes: ["video_diary","aloe_vera","jeff_introduction","vlog_competition","sports","anxiety","struggling","yoga_vibe","fit_traveler","economics"],
      maxindex: 12,
      num_broll_cached: 30,
      video_order: [],
      ui_order: [],
      instructions_order: [],
      recommendation_type: '',
      experiment_index: -1,
      doing_experiment: false,
      five_point_likert: ['Strongly Disagree','Slightly Disagree','Neutral','Slightly Agree','Strongly Agree'],
      twenty_scale_low_high: ['Very Low','2','3','4','5','6','7','8','9','Very High'],
      twenty_questions: ["How confident are you with editing videos with B-Roll?","How mentally demanding was the task?","How physically demanding was the task?","How hurried or rushed was the pace of the task?","How successful were you in accomplishing what you were asked to do?","How hard did you have to work to accomplish your level of performance?","How insecure, discouraged, stressed and annoyed were you?"],
      five_questions: ["The video editing tool was generally helpful to edit the video as I was asked to do.","The video editing tool was helpful with finding relevant B-Roll videos.","The video editing tool was helpful with editing the starting point of an inserted B-Roll","The video editing tool was helpful with editing the duration of an inserted B-Roll","The B-Roll videos that showed up in the search tool were generally relevant.","The separation of B-Roll videos by categories professional and social media style was helpful"],
      recommendation_questions: ["The B-Roll position recommendations were generally helpful","The B-Roll duration recommendations were generally helpful","The B-Roll content recommendations were generally helpful"],
      q0_b: 0,
      showModal: true,
      in_recommendation_session: false,
    }
  }

  showModal () {
    this.setState({showModal: true})
  }

  closeModal () {
    this.setState({showModal: false})
  }

  componentDidMount() {
    var url = new URL(window.location.href);
    var usertype = url.searchParams.get("u");//u===user (e===expert,b=beginner)
    var uitype = url.searchParams.get("c");//c===condition (b===baseline,i===intelligent,t===timeline)
    var v = url.searchParams.get("v");//v===video 1: dog_adoption, 2: economics, 
    var e = url.searchParams.get("e");//is this an experiment or not (1=yes)
    var videotype = "dog_adoption"//that's the default right now

    generateStockToken(this);

    var words = dog_adoption.words
    if (v) {
      v = parseInt(v,10)
      var transcripts = [video_diary,aloe_vera,jeff_introduction,vlog_competition,sports,anxiety,struggling,yoga_vibe,fit_traveler,economics]
      words = transcripts[v].words
      videotype = this.state.videotypes[v]
      this.setState({usertype:usertype,uitype:uitype, videotype: videotype, v: v, words: words})
    } else if (e === '1') {
      generateRandomizedExperiment(this,usertype)
    } else {
      getVideoIndex(this,usertype,uitype)
    }

    document.addEventListener("keydown", this.spaceFunction(), false);
    this.setState({page: 4})
  }
  componentWillUnmount(){
    document.removeEventListener("keydown", this.spaceFunction(), false);
  }

  toggleHelptext = () => (event) => {
    this.setState({show_helptext: !this.state.show_helptext})
  }

  spaceFunction = () => (event) => {
    if(event.keyCode === 32 && !(document.activeElement.id)) {
      //space was pressed so toggle video
      if (document.getElementById("aroll").paused) {
        document.getElementById("aroll").play();
      } else {
        document.getElementById("aroll").pause();
      }
      event.preventDefault();
      event.returnValue = false;
    }
  }

  brollDragStartHandler = (broll_id) => (event) => {
    var text = JSON.stringify({"broll_id":broll_id,"action":0})
    event.dataTransfer.setData('text', text); 
  }

  brollDragDurationHandler = (broll_id) => (event) => {
    var text = JSON.stringify({"broll_id":broll_id,"action":1})
    event.dataTransfer.setData('text', text); 
  }

  brollDropHandler = (current_time) => (event) => {
    event.preventDefault();
    var drag_raw_obj = event.dataTransfer.getData('text');
    if (drag_raw_obj) {
      var drag_obj = JSON.parse(drag_raw_obj);
      var dragged_broll_id = drag_obj.broll_id;
      var drag_action = drag_obj.action;
      var broll_list = this.state.broll_list;
      var N = broll_list.length;
      if (drag_action === 0) {
        //this updates the starting point of this specific added broll
        for (let i = 0;i < N; i++) {
          if (broll_list[i].id === dragged_broll_id) {
            broll_list[i].start = current_time;
            break
          }
        }
        this.setState({broll_list: broll_list})
        uploadDataToServer(this)
      } else if (drag_action === 1) {
        //this updates the duration of this specific added broll
        for (let i = 0;i < N; i++) {
          if (broll_list[i].id === dragged_broll_id) {
            var new_duration = current_time - broll_list[i].start
            console.log(new_duration,"new duration")
            if (new_duration > 0){
              broll_list[i].duration = new_duration*1000;
              console.log(broll_list)
              this.setState({broll_list: broll_list})
              uploadDataToServer(this)
            }
            break
          }
        }
      }
    } else {
      //then we just go there in the video
      console.log('triggered drop event')
      document.getElementById("aroll").currentTime = current_time;
      document.getElementById("aroll").pause();
      this.setState({justclicked:true})
    }
  }

    brollDropHandler2 = (current_time,onlydurationchange,this_broll_id) => (event) => {
    event.preventDefault();
    var drag_obj = JSON.parse(event.dataTransfer.getData('text'));
    var dragged_broll_id = drag_obj.broll_id;
    var drag_action = drag_obj.action;
    var broll_list = this.state.broll_list;
    var N = broll_list.length;

    console.log("received drop event with data",dragged_broll_id)
    console.log("the drop location is",current_time)
    if (drag_action === 0 && dragged_broll_id===this_broll_id) {
      //this updates the starting point of this specific added broll
      for (let i = 0;i < N; i++) {
        if (broll_list[i].id === dragged_broll_id) {
          broll_list[i].start = current_time;
          break
        }
      }
      this.setState({broll_list: broll_list})
      uploadDataToServer(this)
    } else if (drag_action === 1) {
      //this updates the duration of this specific added broll
      for (let i = 0;i < N; i++) {
        if (broll_list[i].id === dragged_broll_id) {
          var new_duration = current_time - broll_list[i].start
          console.log(new_duration,"new duration")
          if (new_duration > 0){
            broll_list[i].duration = new_duration*1000;
            console.log(broll_list)
            this.setState({broll_list: broll_list})
            uploadDataToServer(this)
          }
          break
        }
      }
    }
  }

  brollDelete = () => (event) => {
    var drag_obj = JSON.parse(event.dataTransfer.getData('text'));
    var dragged_broll_id = drag_obj.broll_id;
    var broll_list = this.state.broll_list;
    broll_list = broll_list.filter(function (e) { return e.id !== dragged_broll_id; });
    this.setState({broll_list: broll_list})
    uploadDataToServer(this)
  }

  preventDefault = () => (event) => {
    event.stopPropagation();
    event.preventDefault();
    return false;
  }

  preventDefault2 = () => (event) => {
    event.preventDefault();
  }

  submitGeneralSurvey = () => (event) => {
      event.preventDefault()
      const data = new FormData(event.target);
      var object = {};
      data.forEach(function(value, key){
          object[key] = value;
      });
      object['participantid'] = this.state.participantid % 10000000;
      this.setState({q0_b: parseInt(object['q0_b']),page:4,broll_footage: {"social":[],"professional":[]},broll_thumbnail: {"social":[],"professional":[]},sessionstarttime:Date.now(),broll_list:[],queries:[],searchkey:''})
      var json = JSON.stringify(object);
      console.log(json)
      fetch('https://dapptalk.org/demographicsquestionnaire.php', {
        method: 'POST',
        body: json,
        mode: 'no-cors'
      });
  }

  goToNextExperimentPage = () => (event) => {
      event.preventDefault()
      if (this.state.page === 4 && this.state.broll_list.length < 1) {
        alert("It seems like you did not insert any B-Roll yet. Please insert B-Roll before going to the next task.");
        return;
      }
    //broll_footage: {"social":[],"professional":[]},broll_thumbnail,sessionstarttime,broll_list,queries
    this.setState({broll_footage: {"social":[],"professional":[]},broll_thumbnail: {"social":[],"professional":[]},sessionstarttime:Date.now(),broll_list:[],queries:[],searchkey:'',currentTimeAroll:0})
    if (this.state.page === 4){
      event.preventDefault()
      var experiment_index = this.state.experiment_index;
      experiment_index += 1
      if (experiment_index < 3) {
        console.log(experiment_index,this.state.ui_order)
        var c = this.state.ui_order[experiment_index]
        var v = this.state.video_order[experiment_index]
        var transcripts = [video_diary,aloe_vera,jeff_introduction,vlog_competition,sports,anxiety,struggling,yoga_vibe,fit_traveler,economics]
        var words = transcripts[v].words
        var videotype = this.state.videotypes[v]
        var instructions_index = this.state.instructions_order[experiment_index]
        this.setState({uitype:c, videotype: videotype, v: v, words: words, experiment_index: experiment_index, show_helptext: true, helptext: this.state.helptexts[this.state.instructions_order[experiment_index]],page: 6})
      } else {
        this.setState({page: 6, experiment_index: experiment_index})
      }
    } else {
      //this means we go back to UI from questionnaire
      event.preventDefault()
      console.log("event.preventDefault()")
      const data = new FormData(event.target);
      if (this.state.experiment_index < 3) {
        this.setState({page: 4})
      } else {
        console.log("done with experiment")
        //done with experiment
        this.setState({page: 5})
      }
      var object = {};
      data.forEach(function(value, key){
          object[key] = value;
      });

      object['uitype'] = this.state.u;
      object['uitype'] = this.state.ui_order[this.state.experiment_index-1];
      object['uinumber'] = this.state.experiment_index-1;
      object['uiorder'] = this.state.ui_order.join('-');
      object['videoorder'] = this.state.video_order.join('-');
      object['videotype'] = this.state.video_order[this.state.experiment_index-1];
      object['videoname'] = this.state.videotypes[object['videotype']];
      object['recommendationtype'] = this.state.recommendation_type;
      object['participantid'] = this.state.participantid % 10000000;
      if (object.hasOwnProperty('q0')) {
        object['gain_self_efficacy'] = parseInt(object['q0'])-this.state.q0_b;
      }

      var json = JSON.stringify(object);
      console.log(json)
      fetch('https://dapptalk.org/withinsubjectquestionnaire.php', {
        method: 'POST',
        body: json,
        mode: 'no-cors'
      });
    }
  }

  brollDragStopHandler = (broll_index) => (event) => {
    console.log(broll_index,"called drop")
  }

  changeRecommendationStyle = (name) => (event) => {
    this.setState({current_recommendation_style: name})
  }

  handleTokenChange = () => (event) => {
  	this.setState({token: event.target.value})
  }

  firstMethod = (word) => (event) => {
    event.preventDefault()
    console.log("button clicked",word,event.type)
    this.setState({searchkey:word})
    console.log(this.state.queries)
    this.getImagesByQuery(word);
    return false;
  }

  clickTranscriptIntelligent = (startOffset,idx,keyword) => (event) => {
    const selectedTime = startOffset;
    const thiz = this;
    document.getElementById("aroll").currentTime = selectedTime/1000.0;
    //this.callingUpdate();
    if (keyword.length < 1) {
      document.getElementById("aroll").pause();
      thiz.setState({justclicked:true})
      return
    }
    const searchkey = keyword;
    thiz.setState({searchkey: keyword,justclicked:true})
    var queries = thiz.state.queries
    queries.push(searchkey)
    this.setState({broll_thumbnail: {"social":[],"professional":[]}, broll_footage: {"social":[],"professional":[]}, loadingBroll: true, queries: queries, suggested_duration: 4000, suggested_start_time: -1})
    uploadDataToServer(this)
    thiz.imageAPIcalls(searchkey,this);
  }

  arollPlay = () => (event) => {
    if (document.getElementById("aroll").paused) {
      document.getElementById("aroll").play();
    } else {
      document.getElementById("aroll").pause();
    }
  }

  onKeyPress = () => (event) => {
    if(event.key === 'Enter'){
      //do something
      console.log("detected enter!")
      const thiz = this;
      const searchkey = thiz.state.searchkey;
      var queries = thiz.state.queries
      queries.push(searchkey)
      this.setState({sbroll_thumbnail: {"social":[],"professional":[]}, broll_footage: {"social":[],"professional":[]}, loadingBroll: true, queries: queries, suggested_duration: 4000, suggested_start_time: -1})
      uploadDataToServer(this)
      queries.push(searchkey)
      this.imageAPIcalls(searchkey,this);
    }
  }

  arollReplay = () => (event) => {
  	document.getElementById("aroll").currentTime = 0;
  	document.getElementById("aroll").play();
  }

  showMoreBroll = () => (event) => {
    this.setState({maxindex: this.state.maxindex+12});
  }

  handleSearchChange = () => (event) => {
    this.setState({searchkey: event.target.value});
  }

  callingUpdate = () => (event) => {
    console.log("callingUpdate")
    const broll_list = this.state.broll_list;
    if (this.state.justclicked) {
      prev_pos = event.target.currentTime;
    }
    const N = broll_list.length;
    for (let i = 0;i < N; i++) {
      if (broll_list[i].start >= prev_pos && broll_list[i].start <= event.target.currentTime) {
        showThisBroll("broll_"+i,broll_list[i].duration)
        break;
      }
    }
    prev_pos = event.target.currentTime;
    var date = new Date(null);
    date.setSeconds(event.target.currentTime); // specify value for SECONDS here
    var timestamp = date.toISOString().substr(14, 5);
    this.setState({timestamp: timestamp, currentTimeAroll: event.target.currentTime*1000, justclicked: false})
  }

  addNow = (url,thumbnail,thisranking) => (event) => {
    var current_time = this.state.currentTimeAroll;
    //check if we are currently in b-roll, then don't do anything
    var broll_list = this.state.broll_list;
    console.log("broll length",broll_list.length)
    for (var i=0;i<broll_list.length;i++) {
      var start = broll_list[i].start
      var end = start + broll_list[i].duration/1000
      console.log(current_time,start,end)
      if (current_time/1000 >= start && current_time/1000 < end) {
        console.log('we are currently in a B=roll so wont add this new broll. end.')
        return
      }
    }
    var actual_duration = this.state.suggested_duration
    var actual_position = this.state.suggested_start_time;
    if (actual_duration === 4000) {
      //because otherwise there is a recommended time so we use that
      var broll_duration = document.getElementById(url).duration * 1000
      actual_duration = Math.max(1000,Math.min(8000,broll_duration))
    }
    if (actual_position === -1) {
      actual_position = current_time
    } else {
      actual_position *= 1000
    }
    var query = this.state.searchkey;
    var broll_obj = {"start":actual_position/1000,"duration":actual_duration,"rank":thisranking,"url":url,"thumbnail":thumbnail,"id":url,"query":query,"from_recommendation":this.state.in_recommendation_session};
    broll_list.push(broll_obj);
    this.setState({broll_list:broll_list})
    uploadDataToServer(this)
  }

  getImagesByQuery = (searchquery='') => {
  	const thiz = this;
  	var searchkey = thiz.state.searchkey;
    if (searchquery.length > 0) {
      searchkey = searchquery
    }
    var queries = thiz.state.queries
    queries.push(searchkey)
    this.setState({loadingBroll: true, queries: queries, suggested_duration: 4000, suggested_start_time: -1})
    uploadDataToServer(this)
    this.imageAPIcalls(searchkey,this);
  }

  imageAPIcalls = (searchkey,thiz) => {
    thiz.setState({in_recommendation_session: false})
    var num_broll_cached = thiz.state.num_broll_cached;
    var apiURL = 'https://adobesearch-stage.adobe.io/universal-search/v2/search';
    const token = thiz.state.token;
    var formData = {
      "q": searchkey, 
      "scope": ["stock"], 
      "asset_type": ["video"], 
      "limit": num_broll_cached
    };
    /*
    fetch(apiURL, {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + token,
        'x-api-key': 'AdobeSearchService1',
        'x-product': 'Federer tests',
        'x-product-location': 'Federer container tests',
        'Content-Type': 'application/vnd.adobe.search-request+json'
      },
      body: JSON.stringify(formData)
    }).then((response) => response.json())
      .then((responseData) => { 
        var out = []//footage
        var out2 = []//thumbnail
        for (var i = 0; i < responseData.result_sets[0].items.length;i++) {
          out2.push(responseData.result_sets[0].items[i]._links.rendition[0].href)
          out.push(responseData.result_sets[0].items[i]._links.original.href)
        }
        var broll_footage = thiz.state.broll_footage
        var broll_thumbnail = thiz.state.broll_thumbnail
        broll_footage.professional = out
        broll_thumbnail.professional = out2
        thiz.setState({broll_footage: broll_footage, loadingBroll: false, broll_thumbnail: broll_thumbnail})
      }).catch((err) => { 
        thiz.setState({loadingBroll: false})
        console.log("something went wrong!");
        console.log(err);
      }); 
      */     
      apiURL = 'https://api.giphy.com/v1/gifs/search?q='+searchkey+'&api_key=slZG5tNDBkUfSpd7q8V7le8DLnRaBuZw&limit='+num_broll_cached;
      formData = {email: "testme"};
      fetch(apiURL, {
        method: 'GET',
        dataType: "json",
        data: formData
      }).then((response) => response.json())
        .then((responseData) => { 
          var N = responseData.data.length;
          var out = []//footage
          var out2 = []//thumbnail
          for(let i = 0 ; i < N; i++) {
            var video = responseData.data[i].images.original.mp4;
            var thumb = responseData.data[i].images.original_still.url;
            out2.push(thumb)
            out.push(video)
          }
          var broll_footage = thiz.state.broll_footage
          var broll_thumbnail = thiz.state.broll_thumbnail
          broll_footage.social = out
          broll_thumbnail.social = out2
          thiz.setState({broll_footage: broll_footage, broll_thumbnail: broll_thumbnail, loadingBroll: false})
        }).catch((err) => { 
          console.log("something went wrong!");
          console.log(err);
        });
  }

  getImagesByQueryTerm = (kw,start_time,suggested_duration) => (event) => {
    //this is only called by recommendations so we can track here if we are in recommendation currently
    document.getElementById("aroll").currentTime = start_time;
    const thiz = this;
    const searchkey = kw;
    var queries = thiz.state.queries
    console.log(queries)
    queries.push(searchkey)
    this.setState({loadingBroll: true, queries: queries, searchkey: kw, suggested_duration: suggested_duration, suggested_start_time: start_time, justclicked:true})
    uploadDataToServer(this);
    this.imageAPIcalls(searchkey,this);
    this.setState({in_recommendation_session: true})
  }

  render() {
    if (this.state.page === 10) {
      return (
          <div className="loader top-buffer" style={{textAlign: 'center', marginLeft: '50%'}}></div>
        );
    } else if (this.state.page === 4 && this.state.uitype === "t") {
      return (
        <div className="App">
          <HeaderPanel context={this}/>

          {this.state.show_helptext ? <div className="alert alert-info helpnotification big" role="alert"><div dangerouslySetInnerHTML={{ __html: this.state.helptext }} onClick={this.toggleHelptext()} /></div> : null}
          <div className="container-fluid bottom-buffer"> 
            <div className="row top-buffer">
              <div className="col-12 video-renderer border-right">
                <div className="row">
                  <div className="col-12">
                    <EditingViewBaseline context={this}/>
                  </div>
                </div>

                <div className="row top-buffer">
                  <div className="col-2"></div>
                  <div className="col-7">
                    <input className="form-control" ref="searchInput" id="dappname" onChange={this.handleSearchChange()} onKeyPress={this.onKeyPress()} placeholder="Search B-roll" value={this.state.searchkey}>
                    </input>
                  </div>
                  <div className="col-1">
                    <button onClick={() => this.getImagesByQuery()} className="btn btn-secondary">Search</button>
                  </div>
                </div>
                <div className="row top-buffer bottom-buffer">
                  <div className="col-1"></div>
                  <div className="col-10 timeline-renderer border border-dark" style={{width:'100%'}}>
                    <TimelineView context={this}/>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    {this.state.loadingBroll === true ? <div className="loader top-buffer" style={{textAlign: 'center', marginLeft: '50%'}}></div> : null}
                    <div className="container"> 
                      <div className="row top-buffer">
                        <div key={"first_result"} className="col-6 bg-light">
                          {this.state.broll_footage.social.length > 0 ? <b>{"Social Media"}</b> : null}
                          <RenderBrollResultIntelligent context={this} type={"social"} />
                        </div>
                        <div key={"second_result"} className="col-6">
                          {this.state.broll_footage.professional.length > 0 ? <b>{"Professional"}</b> : null}
                          <RenderBrollResultIntelligent context={this} type={"professional"} />
                        </div>
                      </div>
                      <div className="row top-buffer text-center left-buffer" style={{textAlign: 'center'}}>
                        {this.state.broll_footage.social.length > 0 && this.state.maxindex < this.state.broll_footage.social.length ? <button onClick={this.showMoreBroll()} className="btn btn-secondary">Show More B-Roll</button> : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <FooterPanel context={this}/>
        </div>
      );
	 } else if (this.state.page === 4) {
      return (
        <div className="App">
          <HeaderPanel context={this}/>

          {this.state.show_helptext ? <div className="alert alert-info helpnotification big" role="alert"><div dangerouslySetInnerHTML={{ __html: this.state.helptext }} onClick={this.toggleHelptext()}/></div> : null}
          <div className="container-fluid bottom-buffer"> 
            <div className="row top-buffer">
              <div className="col-8 video-renderer border-right">
                <div className="row">
                  <div className="col-12">
                    <EditingViewBaseline context={this}/>
                  </div>
                </div>

                <div className="row top-buffer">
                  <div className="col-2"></div>
                  <div className="col-7">
                    <input className="form-control" ref="searchInput" id="dappname" onChange={this.handleSearchChange()} onKeyPress={this.onKeyPress()} placeholder="Search B-roll" value={this.state.searchkey}>
                    </input>
                  </div>
                  <div className="col-1">
                    <button onClick={() => this.getImagesByQuery()} className="btn btn-secondary">Search</button>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    {this.state.loadingBroll === true ? <div className="loader top-buffer" style={{textAlign: 'center', marginLeft: '50%'}}></div> : null}
                    <div className="container"> 
                      <div className="row top-buffer">
                        <div key={"first_result"} className="col-12 bg-light">
                          <RenderBrollResultIntelligent context={this} type={"social"} />
                        </div>
                      </div>
                      <div className="row top-buffer text-center left-buffer" style={{textAlign: 'center'}}>
                        {this.state.broll_footage.social.length > 0 && this.state.maxindex < this.state.broll_footage.social.length ? <button onClick={this.showMoreBroll()} className="btn btn-secondary">Show More B-Roll</button> : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-4 overflow-me">
                <ReactTooltip />
                <div className="transcript-renderer text-justify absolute-fix" id="transcript-renderer">
                    <TranscriptViewVeryIntelligent context={this}/>
                </div>
              </div>
            </div>
          </div>
          <FooterPanel context={this}/>
        </div>
      );
      /*
                          {this.state.broll_footage.social.length > 0 ? <b>{"Social Media"}</b> : null}
        
                        <div key={"second_result"} className="col-6">
                          {this.state.broll_footage.professional.length > 0 ? <b>{"Professional"}</b> : null}
                          <RenderBrollResultIntelligent context={this} type={"professional"} />
                        </div>
      */
   } else if (this.state.page===5) {
      return (
        <div className="App">
          <HeaderPanel context={this}/>
          <div>Done, you can close this window now. Thanks for participating!</div>
          <FooterPanel context={this}/>
        </div>
      );
   } else if (this.state.page===6) {
    return (
      <div className="App">
        <HeaderPanel context={this}/>
        <div className='container overflow-me always-scrollbar' key={this.state.experiment_index+"_q_container"}>
          <h4 className='bottom-buffer'>Please answer the following questions about the task you just finished:</h4>
          <form onSubmit={this.goToNextExperimentPage()}>
            <h5 className=''>Video related:</h5>
            <Likert question={'I am generally satisfied with the video that I created'} name={'qv'} labels={this.state.five_point_likert} context={this}/>
            <h5 className=''>Task related:</h5>
            {
              this.state.twenty_questions.map((question, idx) => (
                <Likert question={question} name={'q'+(idx)} labels={this.state.twenty_scale_low_high} context={this}/>
              ))
            }
            <h5 className=''>Tool related:</h5>
            {
              this.state.five_questions.map((question, idx) => (
                <Likert question={question} name={'q'+(idx+this.state.twenty_questions.length)} labels={this.state.five_point_likert} context={this}/>
              ))
            }
            <RecommendationQuestions context={this}/>
            <h5 className=''>General:</h5>
            <div className="form-group">
              <label htmlFor="comment1">Was there anything that you wanted to do with the tool but couldnt do?</label>
              <textarea className="form-control" rows="2" id="comment1" name='qq1'></textarea>
            </div>
            <div className="form-group">
              <label htmlFor="comment2">Additional comments or suggestions:</label>
              <textarea className="form-control" rows="2" id="comment2" name='qq2'></textarea>
            </div>
            <input type="submit" id="submit-form" hidden/>
            <div className="form-group row">
              <div className="col-sm-12">
                <button type="submit" className="btn btn-primary">Done With Survey and Next</button>
              </div>
            </div>
          </form>
        </div>
        <FooterPanel context={this}/>
      </div>
    );
   } else if (this.state.page===7) {
    return (
      <div className="App">
        <HeaderPanel context={this}/>
        <div className='container overflow-me always-scrollbar'>
          <h4 className='bottom-buffer'>Please answer the following questions before you start:</h4>
          <form onSubmit={this.submitGeneralSurvey()}>
            <div className="form-group">
              <label htmlFor="age">Age:</label>
              <select className="form-control" id="age" name="age">
                {
                  [''].concat(Array.from({length: 99}, (v, k) => k+1)).map((age,idx) => (
                    <option key={idx+"_age"}>{idx===0 ? '' : idx}</option>
                  ))
                }
              </select>
            </div>
            <div className="form-group text-center">
              <label htmlFor="gender">Gender:</label>
              <select className="form-control" id="gender" name="gender">
                {
                  ['','Female','Male','Non-Binary'].map((gender,idx) => (
                    <option key={idx+"_gender"}>{gender}</option>
                  ))
                }
              </select>
            </div>
            <Likert question={'Compared to your friends and family, how good are you at editing videos?'} name={'skill'} labels={['Much Worse','Slightly Worse','Similar','Slightly Better','Much Better']} context={this}/>
            <Likert question={'How confident are you at editing videos with B-Roll?'} name={'q0_b'} labels={this.state.twenty_scale_low_high} context={this}/>
            <input type="submit" id="submit-form" hidden/>
            <div className="form-group row">
              <div className="col-sm-12">
                <button type="submit" className="btn btn-primary">Start First Task</button>
              </div>
            </div>
          </form>
        </div>
        <FooterPanel context={this}/>
      </div>
    );
   } else {
    //Compared to your friends and family, how good are you at editing videos? [much worse - much better]
    return(
      null
    );
   }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js